import { render, staticRenderFns } from "./AdCard.vue?vue&type=template&id=0009be53&"
import script from "./AdCard.vue?vue&type=script&lang=js&"
export * from "./AdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports